import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.object.assign";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.weak-set";
import _classCallCheck from "/codebuild/output/src3605708562/src/www-public/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src3605708562/src/www-public/node_modules/@babel/runtime/helpers/esm/createClass";
import { isNativeShadowDom } from '../../../rrweb-snapshot/es/rrweb-snapshot.js';
import { patch, inDom } from '../utils.js';
import { initMutationObserver, initScrollObserver, initAdoptedStyleSheetObserver } from './observer.js';

var ShadowDomManager = /*#__PURE__*/function () {
  function ShadowDomManager(options) {
    _classCallCheck(this, ShadowDomManager);

    this.shadowDoms = new WeakSet();
    this.restoreHandlers = [];
    this.mutationCb = options.mutationCb;
    this.scrollCb = options.scrollCb;
    this.bypassOptions = options.bypassOptions;
    this.mirror = options.mirror;
    this.init();
  }

  _createClass(ShadowDomManager, [{
    key: "init",
    value: function init() {
      this.reset();
      this.patchAttachShadow(Element, document);
    }
  }, {
    key: "addShadowRoot",
    value: function addShadowRoot(shadowRoot, doc) {
      var _this = this;

      if (!isNativeShadowDom(shadowRoot)) return;
      if (this.shadowDoms.has(shadowRoot)) return;
      this.shadowDoms.add(shadowRoot);
      var observer = initMutationObserver(Object.assign(Object.assign({}, this.bypassOptions), {
        doc: doc,
        mutationCb: this.mutationCb,
        mirror: this.mirror,
        shadowDomManager: this
      }), shadowRoot);
      this.restoreHandlers.push(function () {
        return observer.disconnect();
      });
      this.restoreHandlers.push(initScrollObserver(Object.assign(Object.assign({}, this.bypassOptions), {
        scrollCb: this.scrollCb,
        doc: shadowRoot,
        mirror: this.mirror
      })));
      setTimeout(function () {
        if (shadowRoot.adoptedStyleSheets && shadowRoot.adoptedStyleSheets.length > 0) _this.bypassOptions.stylesheetManager.adoptStyleSheets(shadowRoot.adoptedStyleSheets, _this.mirror.getId(shadowRoot.host));

        _this.restoreHandlers.push(initAdoptedStyleSheetObserver({
          mirror: _this.mirror,
          stylesheetManager: _this.bypassOptions.stylesheetManager
        }, shadowRoot));
      }, 0);
    }
  }, {
    key: "observeAttachShadow",
    value: function observeAttachShadow(iframeElement) {
      if (!iframeElement.contentWindow || !iframeElement.contentDocument) return;
      this.patchAttachShadow(iframeElement.contentWindow.Element, iframeElement.contentDocument);
    }
  }, {
    key: "patchAttachShadow",
    value: function patchAttachShadow(element, doc) {
      var manager = this;
      this.restoreHandlers.push(patch(element.prototype, 'attachShadow', function (original) {
        return function (option) {
          var shadowRoot = original.call(this, option);
          if (this.shadowRoot && inDom(this)) manager.addShadowRoot(this.shadowRoot, doc);
          return shadowRoot;
        };
      }));
    }
  }, {
    key: "reset",
    value: function reset() {
      this.restoreHandlers.forEach(function (handler) {
        try {
          handler();
        } catch (e) {}
      });
      this.restoreHandlers = [];
      this.shadowDoms = new WeakSet();
    }
  }]);

  return ShadowDomManager;
}();

export { ShadowDomManager };